import React from 'react';

const FooterShimmer = () => {
    return (
        <footer className="py-8 bg-[#ECEFF1]">
            <div
                className="container mx-auto px-4 py-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:px-[5%]">
                {/* Column 1 - Contact */}
                <div>
                    <div className="h-10 w-32 bg-gray-300 rounded animate-pulse mb-5"></div>
                    <div className="h-6 w-24 bg-gray-300 rounded animate-pulse mb-4"></div>
                    <div className="space-y-3">
                        <div className="h-4 w-40 bg-gray-300 rounded animate-pulse"></div>
                        <div className="h-4 w-56 bg-gray-300 rounded animate-pulse"></div>
                        <div className="h-4 w-48 bg-gray-300 rounded animate-pulse"></div>
                    </div>
                    <div className="flex space-x-4 mt-4">
                        {[1, 2, 3, 4].map((i) => (
                            <div key={i} className="w-8 h-8 bg-gray-300 rounded animate-pulse"></div>
                        ))}
                    </div>
                </div>

                {/* Column 2 - Explorer */}
                <div>
                    <div className="h-6 w-24 bg-gray-300 rounded animate-pulse mb-4"></div>
                    <div className="space-y-3">
                        {[1, 2, 3, 4].map((i) => (
                            <div key={i} className="h-4 w-24 bg-gray-300 rounded animate-pulse"></div>
                        ))}
                    </div>
                </div>

                {/* Column 3 - Categories */}
                <div>
                    <div className="h-6 w-28 bg-gray-300 rounded animate-pulse mb-4"></div>
                    <div className="space-y-3">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <div key={i} className="h-4 w-32 bg-gray-300 rounded animate-pulse"></div>
                        ))}
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default FooterShimmer;